/**
 * Card Grid
 */
import { Component, registerComponent } from 'js/component.js';
import registerIntersectionObserver from 'js/intersections.js';

const componentName = 'card-grid';

export class CardGrid extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        gridContainer: this.element.querySelector(`.${componentName}__container`),
    };

    cardIntersectOptions = {
        querySelector: `.${componentName}`,
        useDefaultClasses: true,
        destroyAfter: true,
        rootMargin: '-120px'
    };

    /**
     * Inject Overflow Container
     */
    injectOverflowContainer = () => {
        const containerEle = document.createElement('div');
        containerEle.classList.add(`${componentName}__overflow-container`);

        this.element.parentNode.insertBefore(containerEle, this.element);
        containerEle.appendChild(this.element);
    };

    /**
     * Initialize Component
     */
    init() {
        const { disableAnimations } = this.elements.gridContainer.dataset;

        // Fire Init Funcs
        if(!disableAnimations) {
            registerIntersectionObserver(this.cardIntersectOptions);
        }
    }
}

registerComponent(`.${componentName}`, CardGrid);
